<template>
  <q-page class="column no-wrap bg-white">
    <SprayChart class="col-grow" />
  </q-page>
</template>

<script setup lang="ts">
import SprayChart from 'components/SprayChart.vue'
</script>
